<template>
<div class="chapter">
<div class="inner_page">
<section class="div_autre" epub:type="preamble">
<div class="pre" id="pre-003"><span epub:type="pagebreak" id="page_XIII" role="doc-pagebreak" title="XIII">
<p class="pre_surtit" epub:type="title"><span><img alt="" class="imagelarge_intext" id="pre2" src="images/pre2.jpg"/></span></p>
<div class="dev">
<p class="txt_courant_ssalinea"><b>I AM GRATEFUL TO MANY</b> friends, family members, colleagues, and conversation partners who have helped to make this book a reality.</p>
<p class="txt_courant_justif">John Witvliet’s chance comment over lunch ten years ago set the trajectory for this project at its inception. Mark Labberton’s and Clay Schmit’s careful reading and encouragement brought shape and depth to this project throughout its development.</p>
<p class="txt_courant_justif">My “preaching and the arts” colleagues at Fuller Theological Seminary, especially Eric Mathis, Joseph Novak, Ahmi Lee, Jeff Frymire, and Vadim Dementyev, provided much-needed clarity, perspective, and good humor as I was first developing these ideas. My colleagues at the Calvin Institute of Christian Worship, especially Satrina Reid, Joanna Wigboldy, Maria Cornou, Becky Snippe, Kristen Verhulst, and Kathy Smith, provided feedback, encouragement, and support as the project neared completion.</p>
<p class="txt_courant_justif">The thoughtful engagement of the many Calvin Theological Seminary students who interacted with a written draft, especially Ryan Shelton and Chan Jang, was a great help in sharpening these ideas. The masterful editorial eye of Karen DeVries strengthened the first draft immensely.</p>
<p class="txt_courant_justif">David McNutt’s energy, warmth, and insight proved invaluable in improving my writing and preparing this book for publication. I am grateful to the whole team at IVP.</p>
<p class="txt_courant_justif">And finally, without the support and sacrifice of my wife, Heidi, and my children, Jude, Hazel, and Nona, this book would have remained nothing but a nice idea. I love you and am grateful for you.</p>
</div>
</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre4.vue?2d7b48b2